import { Box, Typography, useMediaQuery, useTheme } from "@mui/material";
import React from "react";

const Footer = () => {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery('(max-width:890px)');

  return (
    <Box
      sx={{
        position: 'fixed',
        bottom: 0,
        left: isSmallScreen ? 0 : { md: '80px', lg: '80px' },
        width: isSmallScreen ? '100%' : { md: 'calc(100% - 80px)', lg: 'calc(100% - 80px)' },
        height: '50px',
        backgroundColor: '#333231',
        color: 'white',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        boxShadow: '0 -4px 8px rgba(0, 0, 0, 0.2)',
        zIndex: 400,
      }}
    >
      <Typography 
        variant="body2" 
        sx={{ 
          textAlign: 'center', 
          fontSize: { xs: '14px', sm: '16px', md: '16px' }, 
          fontFamily: 'Arial, Helvetica, sans-serif',
          fontWeight: 400,
          px: 1 
        }}
      >
        © 2022 - 2025 FYTN Education and Career Consultant Pvt. Ltd.
      </Typography>
    </Box>
  );
};

export default Footer;
